import React, { memo } from 'react';
import { S3_IMAGES_URL } from 'util/constants';
import StudioLogo from '@ozoneuniverse/ui-components/build-pkg/src/components/logo/StudioLogo';
import NavigationLogoSection from './zepeto/ZepetoLogo';
import NavigationUnityLogoSection from './unity-web-builder/UnityLogo';
import NavigationXsollaLogoSection from './xsolla/XsollaLogo';
import { CDN_MARKETPLACE } from '@src/components/scene/assets/baseUrl';
import { Flex } from 'antd';
import Image from 'next/image';
import { useBranding } from './useBranding';

const Logo = ({ styles, inEditor, externalLogoURL, isDark }) => {
  const { isZepeto, isXsolla, isUnity } = useBranding();

  if (isZepeto) {
    return <NavigationLogoSection styles={styles} />;
  }

  if (isXsolla) {
    return <NavigationXsollaLogoSection styles={styles} />;
  }

  if (inEditor && isUnity) {
    return <NavigationUnityLogoSection styles={styles} />;
  }

  const darkThemeLogoUrl = `${CDN_MARKETPLACE}/assets/logos/logo-for-dark-theme.png`;

  if (isDark) {
    return (
      <Flex align='center'>
        <Image src={darkThemeLogoUrl} alt='Logo' width={130} height={35} />
      </Flex>
    );
  }

  return (
    <StudioLogo
      s3ImagesUrl={S3_IMAGES_URL as string}
      inEditor={inEditor}
      externalLogoURL={externalLogoURL}
    />
  );
};

export default memo(Logo);
